export default __webpack_public_path__ + "static/media/holidays-city-2.0ceba279.png";